import { render, staticRenderFns } from "./WikiMemberInviteList.vue?vue&type=template&id=1f81a559"
import script from "./WikiMemberInviteList.vue?vue&type=script&lang=ts"
export * from "./WikiMemberInviteList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports